<template>
    <div class="py-3">
        <div class="container">
            <!-- trip profile navbar !-->
            <TravelExpenseReportTabs :linksDisabled=false :expenseReportID=existingExpenseReportID ref="nav"></TravelExpenseReportTabs>
            <div class="row">
                <div class="col-md-12">
                    <div v-if="!loading && expenseReportStatusTypeId > 1" style="text-align:center; color:red;">Changes will not be saved unless Save button is clicked</div>
                    <h4 style="font-weight:900; margin-bottom:0px;">
                        Air <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
                    </h4>
                    <div class="my-1" style="margin-top:0px;">{{existingExpenseReport.expenseReportStatusTypeName}}</div>
                    <ValidationAlertComponent v-if="!loading" :expenseReportID="existingExpenseReportID" :area="'air'" :key="validationKey"></ValidationAlertComponent>
                    <div v-if="!loading">
                        <div v-for="(t,tIndex) in existingAirFare.airfareTickets">
                            <form class="" v-on:submit.prevent>
                                <div class="form-group"></div>
                                <label>
                                    Ticket {{tIndex + 1}} <button type="button" class="close" aria-label="Close" @click="showRemovalModal(ItemRemoveType.Airfare, tIndex,null)">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </label>
                                <div class="form-group">
                                    <!--<div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <label class="btn btn-secondary btn-sm active">Domestic </label>
                                    <label class="btn btn-secondary btn-sm" aria-pressed="false">Foreign </label>
                                </div>-->
                                </div>

                                <b-form-group label="Airline Carrier">
                                    <b-form-select v-model="t.airlineId" class="w-50" :options="airlineTypes" value-field="id" text-field="name">
                                        <option :value="null" disabled>Choose an option</option>
                                    </b-form-select>
                                </b-form-group>
                                <div v-if="t.airlineId == 9">
                                    <label>
                                        Please select applicable exception
                                        <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="foreignPopUpWarning" icon="info-circle" />
                                    </label>
                                    <b-form-group>
                                        <b-form-select v-model="t.airfareForeignAirlineReasonTypeId" class="w-50" :options="foreignAirlineReasonTypes" value-field="id" text-field="displayName">
                                            <option :value="null" disabled>Choose an option</option>
                                        </b-form-select>
                                    </b-form-group>
                                </div>

                                <div v-if="tripHasPersonalDay" style="margin-bottom:5px;">
                                    Because you indicated you had personal travel through a non-business airport, only the lesser of actual costs or the business portion will be reimbursed.
                                </div>

                                <div class="form-group">
                                    <label v-if="tripHasPersonalDay == false">Ticket Cost</label>
                                    <label v-if="tripHasPersonalDay == true">Business-only airfare <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="'Please enter the airfare amount as if you had only traveled for business. Attachment must be a quote for round-trip flight using the dates for business-only travel.'" icon="info-circle" /></label>
                                    <div class="input-group w-25">
                                        <input v-model="t.businessAmount" type="number" @focus="$event.target.select()" class="form-control" placeholder="Enter cost">
                                        <div class="input-group-append"><button class="btn btn-secondary" type="button" @click="$bvModal.show('businessAmountAttachmentsModal'+ tIndex)">Attach</button></div>
                                    </div>
                                    <span style="cursor: pointer">
                                        <div v-for="(baa, baaIndex) in t.businessAmountAttachments">
                                            <span @click="downloadFileInNewWindow(baa)">{{baa.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.AirfareAttachmentBusiness,tIndex,baaIndex)">&times;</span>
                                        </div>
                                    </span>
                                    <b-modal :id="'businessAmountAttachmentsModal' + tIndex" centered title="Add Receipt" :hide-footer=true>
                                        <AttachmentComponent :expenseReportId="existingExpenseReportID" :attachments="t.businessAmountAttachments" @fileUploadDone="$bvModal.hide('businessAmountAttachmentsModal'+ tIndex)"></AttachmentComponent>
                                    </b-modal>
                                </div>

                                <div v-if="tripHasPersonalDay == true" class="form-group">
                                    <label>Actual airfare</label>
                                    <div class="input-group w-25">
                                        <input v-model="t.personalAmount" type="number" @focus="$event.target.select()" class="form-control" placeholder="Enter cost">
                                        <div class="input-group-append"><button class="btn btn-secondary" type="button" @click="$bvModal.show('personalAmountAttachmentsModal'+ tIndex)">Attach</button></div>
                                    </div>
                                    <span style="cursor: pointer">
                                        <div v-for="(baa, baaIndex) in t.personalAmountAttachments">
                                            <span @click="downloadFileInNewWindow(baa)">{{baa.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.AirfareAttachmentPersonal, tIndex, baaIndex)">&times;</span>
                                        </div>
                                    </span>
                                    <b-modal :id="'personalAmountAttachmentsModal' + tIndex" centered title="Add Receipt" :hide-footer=true>
                                        <AttachmentComponent :expenseReportId="existingExpenseReportID" :attachments="t.personalAmountAttachments" @fileUploadDone="$bvModal.hide('personalAmountAttachmentsModal'+ tIndex)"></AttachmentComponent>
                                    </b-modal>
                                </div>
                            </form>

                            <b-form-group label="Was this ticket non-refundable?">
                                <b-form-radio-group v-model="t.isNonRefundable"
                                                    :options="[{ text: 'Yes', value:true },{ text: 'No', value:false }]"></b-form-radio-group>
                            </b-form-group>

                            <b-form-group v-if="t.isNonRefundable == false" label="Please select applicable exception">
                                <b-form-select v-model="t.nonRefundableTypeId" class="w-50" :options="nonRefundableTypes" value-field="id" text-field="displayName">
                                    <option :value="null" disabled>Choose an option</option>
                                </b-form-select>
                            </b-form-group>

                            <b-form-group label="Was this ticket for business/first class?">
                                <b-form-radio-group v-model="t.isFirstClass"
                                                    :options="[{ text: 'Yes', value:true },{ text: 'No', value:false }]"></b-form-radio-group>
                            </b-form-group>

                            <b-form-group v-if="t.isFirstClass" label="Please select applicable exception">
                                <b-form-select v-model="t.firstClassTypeId" class="w-50" :options="firstClassTypes" value-field="id" text-field="displayName">
                                    <option :value="null" disabled>Choose an option</option>
                                </b-form-select>
                            </b-form-group>
                        </div>
                        <div class="form-group">
                            <a class="btn btn-secondary btn-sm btn-text-white" @click="addTicket">Add Ticket</a>
                        </div>

                        <!--baggage fee  -->
                        <div v-for="(b,bIndex) in existingAirFare.airfareBaggages" class="form-group">
                            <label>
                                Baggage Fee {{bIndex +  1}}
                                <button type="button" class="close" aria-label="Close" @click="showRemovalModal(ItemRemoveType.Baggage, bIndex)">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </label>
                            <div class="input-group w-25">
                                <input v-model="b.amount" type="number" @focus="$event.target.select()" class="form-control w-25" placeholder="Enter fee">
                                <div class="input-group-append" v-if="b.amount > 75">
                                    <button class="btn btn-secondary" type="button" @click="$bvModal.show('baggageAmountAttachmentsModal' + bIndex)">Attach</button>
                                </div>
                            </div>
                            <span style="cursor: pointer">
                                <div v-for="(baa,baaIndex) in b.amountAttachments">
                                    <span @click="downloadFileInNewWindow(baa)">{{baa.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.BaggageAttachment, bIndex, baaIndex)">&times;</span>
                                </div>
                            </span>

                            <!-- baggage attahcment modal -->
                            <b-modal :id="'baggageAmountAttachmentsModal' + bIndex" centered title="Add Receipt" :hide-footer=true>
                                <AttachmentComponent :expenseReportId="existingExpenseReportID" :attachments="b.amountAttachments" @fileUploadDone="$bvModal.hide('baggageAmountAttachmentsModal' + bIndex)"></AttachmentComponent>
                            </b-modal>
                        </div>

                        <div class="form-group">
                            <a class="btn btn-secondary btn-sm btn-text-white" @click="addBaggageFee">Add Baggage Fee</a>
                        </div>
                        <b-form-textarea id="supportingRemark"
                                         v-model="existingAirFare.supportingRemark"
                                         placeholder="Supporting remarks, if needed"
                                         rows="1"
                                         max-rows="3"
                                         style="margin-bottom:15px;">
                        </b-form-textarea>
                        <button type="submit" class="btn btn-primary btn-lg" @click="saveAirSection">Save</button>
                    </div>
                </div>
                <CommentsComponent v-if="!loading && expenseReportStatusTypeId > 1" :expenseReportID="existingExpenseReportID" :area="'air'"></CommentsComponent>
                <div v-if="!loading  && expenseReportStatusTypeId > 1" class="col-md-12">
                    <!-- audit history comp -->
                    <AuditHistoryComponent :expenseReportID="existingExpenseReportID" :area="'air'"></AuditHistoryComponent>
                </div>
            </div>
        </div>
        <modal title="Confirm Delete?" :is-small="true" v-if="show_modal_remove" @close="show_modal = false">
            <div class="modal-body">
                Are you sure you want to remove this item?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="removeItem(itemTypeToRemove, itemToRemove, attachmentToRemove)">Delete</button>
                <button type="button" class="btn btn-primary" @click="show_modal_remove = false">Cancel</button>
            </div>
        </modal>
        <modal title="Save progress?" :is-small="true" v-if="show_modal" @close="show_modal = false">
            <div class="modal-body">
                Save changes to expense report?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="saveAndContinue(true)">Save</button>
                <button type="button" class="btn btn-primary" @click="saveAndContinue(false)">Cancel</button>
            </div>
        </modal>
    </div>
</template>
<style scoped>
    .btn-text-white {
        color: white !important;
    }
</style>

<script>
    // @ is an alias to /src
    import TravelExpenseReportTabs from '@/components/TravelExpenseReportTabs.vue'
    import AttachmentComponent from '@/components/AttachmentComponent.vue'
    import AuditHistoryComponent from '@/components/AuditHistoryComponent.vue'
    import CommentsComponent from '@/components/CommentsComponent.vue'
    import ValidationAlertComponent from '@/components/ValidationAlertComponent.vue'
    import modal from '@/components/modal.vue'
    export default {
        name: 'air',
        components: {
            TravelExpenseReportTabs,
            AttachmentComponent,
            AuditHistoryComponent,
            CommentsComponent,
            ValidationAlertComponent,
            modal
        },
        created() {
            if (this.$route.params.erid) {
                this.existingExpenseReportID = this.$route.params.erid;
                this.getAirlineTypes()
                this.getNonRefundableTypes()
                this.getForeignAirlineReasons()
                this.getFirstClassTypes()
                this.getExistingAirDetails(this.existingExpenseReportID)
                this.getExpenseReport()

            }
        },
        data: function () {
            return {
                validationKey: 0,
                foreignPopUpWarning: {
                    content: `Additional resources: <br>
                              OpenSkies - <a href="http://www.gsa.gov/openskies" target="_blank"> http://www.gsa.gov/openskies</a> <br>
                              Federal Travel Regulation exceptions(Chapter 301) - <a href="https://www.gsa.gov/policy-regulations/regulations/federal-travel-regulation-ftr" target="_blank">  https://www.gsa.gov/policy-regulations/regulations/federal-travel-regulation-ftr</a> <br>` ,
                    html: true
                },
                expenseReportStatusTypeId: 1,
                show_modal: false,
                loading: true,
                existingExpenseReportID: null,
                existingExpenseReport: null,
                tripHasPersonalDay: false,
                airlineTypes: [],
                foreignAirlineReasonTypes: [],
                nonRefundableTypes: [],
                firstClassTypes: [],
                existingAirFare: {
                    airfareTickets: [],
                    airfareBaggages: []
                },
                show_modal: false,
                navNext: null,
                show_modal_remove: false,
                itemToRemove: null,
                attachmentToRemove: null,
                itemTypeToRemove: null,
                ItemRemoveType: {
                    Airfare:0,
                    AirfareAttachmentBusiness: 1,
                    AirfareAttachmentPersonal: 2,
                    Baggage: 3,
                    BaggageAttachment: 4,

                }
            }
        },
        computed: {
            hashData: function () {
                return JSON.stringify(this.$data.existingAirFare);
            }
        },
        methods: {
            removeItem(itemType, index, attachIndex) {
                switch (itemType) {
                    case 0:
                        this.removeTicket(index);
                        break;
                    case 1:
                        this.removeBusinessAttachment(index,attachIndex);
                        break;
                    case 2:
                        this.removePersonalAttachment(index, attachIndex);
                        break;
                    case 3:
                        this.removeBaggageFee(index);
                        break;
                    case 4:
                        this.removeBaggageAttachment(index,attachIndex);
                        break;
                    default:
                        break;
                }
                this.show_modal_remove = false;
            },
            showRemovalModal(itemType, index, attachIndex) {
                this.itemToRemove = index;
                this.itemTypeToRemove = itemType;
                this.attachmentToRemove = attachIndex;
                this.show_modal_remove = true;
            },
            downloadFileInNewWindow(params) {
                console.log(params)
                let documentType = 'receipts/';
                if (params.attachmentTypeId == 2) {
                    documentType = 'InstitutionalDocuments/'
                }
                this.$http
                    .get(documentType + params.attachmentId + '/Download', {
                        responseType: 'blob',
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        const file = new Blob(
                            [response.data],
                            { type: response.headers['content-type'] });
                        const downloadUrl = window.URL.createObjectURL(file);
                        window.open(downloadUrl);
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            getExpenseReport() {
                this.$http
                    .get(`expensereports/${this.existingExpenseReportID}`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.existingExpenseReport = response.data;

                        //if trip personal day was chagned ensure personalAmount is set to null on reload so it calculates properly on backend for totals.
                        this.tripHasPersonalDay = this.existingExpenseReport.trip.additionalAirport;
                        if (this.tripHasPersonalDay == false) {
                            this.existingAirFare.airfareTickets.forEach(t => t.personalAmount = null)
                        }

                        this.expenseReportStatusTypeId = response.data.expenseReportStatusTypeId;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            removeTicket(tIndex) {
                this.show_modal_delete_airfare = false;
                this.existingAirFare.airfareTickets.splice(tIndex, 1);
            },
            removeBaggageFee(bIndex) {
                this.show_modal_delete_baggage = false;
                this.existingAirFare.airfareBaggages.splice(bIndex, 1);
            },
            removePersonalAttachment(ticketIndex, personalAttahcmentIndex) {
                this.existingAirFare.airfareTickets[ticketIndex].personalAmountAttachments.splice(personalAttahcmentIndex, 1);
            },
            removeBusinessAttachment(ticketIndex, businessAttahcmentIndex) {
                this.existingAirFare.airfareTickets[ticketIndex].businessAmountAttachments.splice(businessAttahcmentIndex, 1);
            },
            removeBaggageAttachment(baggageIndex, baggageAttahcmentIndex) {
                this.show_modal_delete_baggage_attach = false;
                this.existingAirFare.airfareBaggages[baggageIndex].amountAttachments.splice(baggageAttahcmentIndex, 1);
            },
            isValid() {
                let validationErrors = [];

                if (_.filter(this.existingAirFare.airfareTickets, ['isFirstClass', null]).length > 0) {
                    validationErrors.push("Answer required for 'Was this ticket for business/first class?'")
                }

                //remove this attachment check on frontend per maui 2/3/2020
                //let attachmentCheck = _.filter(this.existingAirFare.airfareTickets, function (af) {
                //    if (af.businessAmountAttachments.length == 0) {
                //        return af;
                //    }
                //})

                //if (attachmentCheck.length >= 1) {
                //    validationErrors.push("Attachment required for ticket")
                //}

                if (_.filter(this.existingAirFare.airfareTickets, ['isNonRefundable', null]).length > 0) {
                    validationErrors.push("Answer required 'Was this ticket non-refundable?'")
                }

                //if validation errors return
                if (!_.isEmpty(validationErrors)) {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        duration: 3500,
                        text: validationErrors.join("<br>")
                    });
                    return false;
                }
                return true;
            },
            addDefaultBaggageFeeObjectIfDoesNotExist() {
                if (!this.existingAirFare.airfareBaggages.length > 0) {

                    this.addBaggageFee();
                }
            },
            addBaggageFee() {
                this.existingAirFare.airfareBaggages.push({
                    amount: null,
                    amountAttachments: [],
                    id: null
                })
            },
            addDefaultTicketObjectIfDoesNotExist() {
                if (!this.existingAirFare.airfareTickets.length > 0) {
                    this.addTicket();
                }
            },
            addTicket() {
                this.existingAirFare.airfareTickets.push({
                    airlineId: null,
                    personalAmount: null,
                    businessAmount: null,
                    isNonRefundable: null,
                    nonRefundableTypeId: null,
                    isFirstClass: null,
                    firstClassTypeId: null,
                    businessAmountAttachments: [],
                    personalAmountAttachments: [],
                    id: null
                })
            },
            getAirlineTypes() {
                this.$http
                    .get(`Airfares/Airlines/`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.airlineTypes = _.orderBy(response.data, 'displayOrder', 'asc')
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            getNonRefundableTypes() {
                this.$http
                    .get(`Airfares/NonRefundableTypes/`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.nonRefundableTypes = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            getFirstClassTypes() {
                this.$http
                    .get(`Airfares/FirstClassTypes/`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.firstClassTypes = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            getForeignAirlineReasons() {
                this.$http
                    .get(`Airfares/ForeignAirlineReasonTypes/`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.foreignAirlineReasonTypes = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            async saveAndContinue(save) {
                let success = false;
                if (save) {
                    success = await this.saveAirSection();
                    if (success) {
                        this.navNext()
                    } else {
                        this.navNext(false)
                    }
                }
                else {
                    this.navNext()
                }
            },
            async getExistingAirDetails(erID) {
                await this.$http
                    .get(`expensereports/${erID}/Airfare`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        response.data.airfareTickets = _.orderBy(response.data.airfareTickets, "id")
                        response.data.airfareBaggages = _.orderBy(response.data.airfareBaggages, "id")
                        this.existingAirFare = response.data;
                        this.hash = this.hashData;
                        //comment out for now
                        //this.addDefaultBaggageFeeObjectIfDoesNotExist();
                        //this.addDefaultTicketObjectIfDoesNotExist();
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false
                    )
            },
            async saveAirSection() {
                let isSuccess = false;
                if (this.isValid()) {

                    //if (this.tripHasPersonalDay == false) {
                    //    this.existingAirFare.airfareTickets.forEach((ticket) => { ticket.personalAmount = ticket.businessAmount })
                    //}

                    await this.$http
                        .put('Airfares/', this.existingAirFare, {
                            headers: {
                                "Authorization": "Bearer " + this.msal.accessToken
                            }
                        })
                        .then(response => {

                            this.$notify({
                                group: 'success',
                                type: 'success ',
                                title: 'Success',
                                text: "Airfare saved successfully"
                            });
                            this.$refs.nav.getSummaryCosts();
                            this.validationKey += 1;
                            isSuccess = true;
                            window.scrollTo(0, 0);
                        })
                        .catch(error => {
                            let guiError = error;

                            if (error.response.data) {
                                guiError = error.response.data.join("<br>")
                            }

                            this.$notify({
                                group: 'errors',
                                type: 'error',
                                title: 'Error',
                                text: guiError
                            });
                            this.errored = true
                        })
                }
                return isSuccess;
            }
        },
        //auto save when navigating away from section
        async beforeRouteLeave(to, from, next) {
            if (this.expenseReportStatusTypeId > 1) {
                next()
            }
            else {

                this.navNext = next;

                const dataToCompare = this.hashData;

                if (dataToCompare === this.hash) {
                    console.log("No changes");
                    next();
                }
                else {
                    console.log("Data changed");
                    this.show_modal = true;
                }
            }
        }
    }
</script>